import * as yup from "yup";
import {AxiosResponse} from "axios";
import {UseQueryResult} from "@tanstack/react-query";
import {BasePaginationResponse, BaseResponse} from "../data/model/BaseResponse";
import React from "react";

// export const BASE_URL = "http://151.97.13.187/ihosp" TODO !!!!!
// export const BASE_URL = "https://smartvenues-ee94d-default-rtdb.europe-west1.firebasedatabase.app/url.json"

export const DEBUG = false;
// export const BASE_URL = "https://smartvenuesbe-7b6c5261eebf.herokuapp.com"
export const BASE_URL = DEBUG ? "http://0.0.0.0:8080" : "https://server.smartvenues.net"
export const BASE_FILE_URL = "https://www.enjoyetna.com/api"
export const QDRANT_BE_URL = "https://chatbot.smartvenues.net/chatbot/qdrant/products"
// export const BASE_URL = "https://server.smartvenues.net"
// export const BASE_URL = "http://smartvenuesbe-env.eba-3uf4bt2y.eu-west-1.elasticbeanstalk.com"
// export const BASE_URL = "https://enjoyetna.com/api/smartvenues.php"
// export const BASE_URL = "http://0.0.0.0:8080" // TODO!!!
// export const BASE_URL = "http://localhost:8080" // TODO!!!
// export const BASE_URL = "https://enjoyetna.com/api/bridge.php";
export const BASE_URL_BRIDGE = "https://chatbot.smartvenues.net/chatbot";
export const IS_SMARTVENUES = false; // TODO

export function formatDate(date: Date) {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
}

export function getFormattedDataFromTimestamp(date ?: number | string) {
    if (!date) return null;

    let dateObject
    if (typeof date === "string") {
        const dateLenght = date.length;
        dateObject = new Date(dateLenght < 13 ? (parseInt(date) * 1000) : parseInt(date));
    } else {
        const dateLenght: number = (date as number).toString().length;
        dateObject = new Date(dateLenght < 13 ? ((date as number) * 1000) : (date as number));
    }
    return getFormattedData(dateObject);
}

export function getConsumeWithin(value?: string) {
    if (!value) return null;

    const number = value.split('@')[0];
    const period = value.split('@')[1];

    let periodValue;
    switch (period) {
        case "m":
            periodValue = "mesi";
            break;
        case "y":
            periodValue = "anni";
            break
        case "d":
        default:
            periodValue = "giorni";
            break;
    }

    return `${number} ${periodValue}`;
}

export function getFormattedData(date: Date) {
    return date.toLocaleDateString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    });
}

export const parseDate = (str: string): Date => {
    const parts = str.split("/");
    const newStr = `${parts[1]}/${parts[0]}/${parts[2]}`;
    return new Date(newStr);
};

export const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    ['link', 'image'],
    [{'size': ['small', 'medium', 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],

    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],

    ['clean']                                         // remove formatting button
];

export function removeItemAtIndex<T>(arr: T[], index: number) {
    const newArr = [...arr];
    newArr.splice(index, 1);
    return newArr;
}

export function addListElement<T>(list: T[], newElement: T): T[] {
    return [...list, newElement];
}

export function yupNumberEmpty() {
    return yup
        .number()
        .transform((value, originalValue) =>
            originalValue.trim() === "" ? undefined : value
        );
}

export function notEmptyOrUndefined<T>(value?: T) {
    return value === '' ? undefined : value;
}

export function yupValueOrUndefined() {
    return yup.string()
        .transform((value, originalValue) => originalValue.trim() === '' ? undefined : value);
}

export function usePaginationData<T>(response: UseQueryResult<AxiosResponse<any, any> | undefined, Error>) {
    const {data: dataAll, isLoading, refetch} = response || {};
    const basePaginationResponse = dataAll?.data as BasePaginationResponse<T> || {};
    const {data: dataPagination} = basePaginationResponse || {};
    const {data, totPage, isLastPage} = dataPagination || {};

    return {
        data,
        isLoading,
        refetch,
        totPage,
        isLastPage
    }
}

export function priceNumber(price: number) {
    const formattedPrice = price.toFixed(2);
    return `${formattedPrice.replace('.', ',')}€`;
}

export function getData<T>(value: AxiosResponse<any, any> | undefined) {
    return (
        (value as AxiosResponse<any, any> | undefined)?.data as BaseResponse<T>
    )?.data;
}

export const getFileMediaType = (file: File) => {
    const type = file.type;
    let mediaType: "image" | "video" | "audio" | "file" | "unknown";

    if (type.match('image.*')) {
        mediaType = 'image';
    } else if (type.match('video.*')) {
        mediaType = 'video';
    } else if (type.match('audio.*')) {
        mediaType = 'audio';
    } else {
        mediaType = 'file';
    }

    return mediaType;
};

export function getQrRandomHash() {
    const timestamp = Date.now().toString();
    return btoa(timestamp).replace(/[+/=]/g, '');
}

export type SubmitHandler<T> = (data: T, event?: React.BaseSyntheticEvent) => void | Promise<void>;
